import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 2338FC6A-1234-4A1F-AF6D-CFD45C92A2DF
 * name arrow-expand-down
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-expand-down.svg
 * tags
 * - Arrow 
 */
export const ArrowExpandDownIcon = createSvgIcon(<><path d="M22,4V2H2V4H11V18.17L5.5,12.67L4.08,14.08L12,22L19.92,14.08L18.5,12.67L13,18.17V4H22Z" /></>, 'ArrowExpandDownIcon');
export default ArrowExpandDownIcon